// extracted by mini-css-extract-plugin
export var hidden = "points-notification-module--hidden--311af";
export var pointNotificationFlash = "points-notification-module--point-notification-flash--237b2";
export var pointNotificationIn = "points-notification-module--point-notification-in--cd22c";
export var pointsNotification = "points-notification-module--points-notification--6de82";